import './style.styl';

angular
  .module(__filename, [])

  .config(
    ngInject(($stateProvider) =>
      $stateProvider.state('public.whoops', {
        url: '/whoops',
        template: require('./template'),
        bypassAuth: true,
      }),
    ),
  );

export default __filename;
